module.exports = __webpack_public_path__ + "duo_38x38.9944c099fa2327e9e4da2b33c9516593.png";